<template>
  <div v-if="SData">
    <v-dialog v-model="ModalEdit" persistent max-width="80%">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Edit Data</v-toolbar-title>
        </v-toolbar>

        <div class="pa-5">
          <div class="mb-5">
            <h3>EDIT ASN YANG MENJABAT</h3>
          </div>

          <div v-if="SData.asn">
            <v-text-field
              v-model="unor_name"
              label="Unit"
              outlined
              dense
              readonly
              filled
            ></v-text-field>

            <v-text-field
              v-model="SData.title"
              label="Nama Jabatan"
              outlined
              dense
              readonly
              filled
            ></v-text-field>

            <v-divider class="mb-5 mt-n2"></v-divider>

            <v-text-field
              v-model="SData.asn.nip"
              label="Nomor Induk Pegawai"
              :loading="LCari"
              outlined
              dense
            >
              <template v-slot:append-outer>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      fab
                      depressed
                      small
                      color="primary"
                      class="mt-n2"
                      v-bind="attrs"
                      v-on="on"
                      @click="cari()"
                    >
                      <v-icon> mdi-account-search </v-icon>
                    </v-btn>
                  </template>
                  <span>Cari</span>
                </v-tooltip>
              </template>
            </v-text-field>

            <v-row dense class="mb-n6">
              <v-col cols="12" md="8">
                <v-text-field
                  v-model="SData.asn.nama"
                  label="Nama ASN"
                  outlined
                  dense
                  readonly
                  filled
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="2">
                <v-menu
                  v-model="tmtJabatanPicker"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="SData.tmt_jabatan"
                      label="TMT Jabatan"
                      append-icon="mdi-calendar"
                      dense
                      outlined
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="SData.tmt_jabatan"
                    @input="tmtJabatanPicker = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" md="2">
                <v-menu
                  v-model="tmtPelantikanPicker"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="SData.tmt_pelantikan"
                      label="TMT Pelantikan"
                      append-icon="mdi-calendar"
                      dense
                      outlined
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="SData.tmt_pelantikan"
                    @input="tmtPelantikanPicker = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-divider class="my-3"></v-divider>

            <!-- Surat Keputusan -->
            <v-row dense>
              <v-col cols="12">
                <span>Surat Keputusan (SK)</span>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  hint="Pejabat Yang Menandatangani"
                  v-model="SData.sk.pejabat"
                  persistent-hint
                  dense
                  flat
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  hint="Nomor"
                  v-model="SData.sk.nomor"
                  persistent-hint
                  dense
                  flat
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-menu
                  v-model="skTanggalPicker"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="SData.sk.tanggal"
                      hint="Tanggal"
                      append-icon="mdi-calendar"
                      persistent-hint
                      dense
                      outlined
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="SData.sk.tanggal"
                    @input="skTanggalPicker = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-divider class="mb-5 mt-2"></v-divider>

            <v-row dense>
              <v-col cols="12" md="12">
                <v-select
                  v-model="SData.shift_kerja"
                  label="Shift Kerja"
                  :items="iShift"
                  item-value="id"
                  item-text="nama"
                  outlined
                  dense
                ></v-select>
              </v-col>
            </v-row>
          </div>

          <v-divider class="my-3"></v-divider>

          <div class="text-right">
            <v-btn
              class="mr-2"
              color="blue-grey lighten-4"
              depressed
              @click="closeModal()"
            >
              Batal
            </v-btn>

            <v-btn color="success" @click="edit()" v-if="LBtn">
              <v-icon left> mdi-content-save </v-icon>
              Simpan
            </v-btn>

            <v-btn color="success" loading v-else>
              <v-icon left> mdi-content-save </v-icon>
              Simpan
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Cookie from "@/helper/cookie.js";

import SView from "@/store/anjab/mutasi/view";
import SEdit from "@/store/anjab/mutasi/edit";

export default {
  computed: {
    ModalEdit: {
      get() {
        return SEdit.state.ModalEdit;
      },
      set(value) {
        SEdit.commit("TModal", value);
      },
    },

    SData: {
      get() {
        return SEdit.state.data;
      },

      set(value) {
        console.log(value);
      },
    },
  },

  watch: {
    async ModalEdit() {},
  },

  data: () => ({
    token: Cookie.get("token"),
    unor_name: localStorage.getItem("unor"),
    LBtn: true,
    LCari: false,

    tmtJabatanPicker: false,
    tmtPelantikanPicker: false,
    skTanggalPicker: false,

    iShift: [
      {
        id: "pagi",
        nama: "Pagi",
      },
      {
        id: "siang",
        nama: "Siang",
      },
      {
        id: "malam",
        nama: "Malam",
      },
    ],
  }),

  methods: {
    reset() {
      this.idASN = "";
    },

    async edit() {
      this.LBtn = false;
      let data = {
        peta_id: this.SData.peta_id,
        asn_id: this.SData.asn.id,
        asn_nip: this.SData.asn.nip,
        asn_nama: this.SData.asn.nama,
        tmt_jabatan: this.SData.tmt_jabatan,
        tmt_pelantikan: this.SData.tmt_pelantikan,
        sk_pejabat: this.SData.sk.pejabat,
        sk_nomor: this.SData.sk.nomor,
        sk_tanggal: this.SData.sk.tanggal,
        shift_kerja: this.SData.shift_kerja,
      };

      const url = process.env.VUE_APP_API + "petajab/asn";
      this.axios
        .put(url, data, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((res) => {
          this.LBtn = true;
          if (res.data.success) {
            SView.commit("refreshData", true);
            SView.commit("alert", res.data.message);
            SView.commit("berhasilAlert", true);
            SView.commit("gagalAlert", false);
            SView.commit("success", res.data.success);
          } else {
            SView.commit("refreshData", true);
            SView.commit("alert", res.data.message);
            SView.commit("gagalAlert", true);
            SView.commit("berhasilAlert", false);
            SView.commit("success", res.data.success);
          }

          this.closeModal();
        })
        .catch((error) => {
          SView.commit("refreshData", true);
          SView.commit("alert", error.response.data.message);
          SView.commit("gagalAlert", true);
          SView.commit("berhasilAlert", false);
          SView.commit("success", error.response.data.success);
          console.log(error.response.status);
          console.log("Error", error.message);
          this.LBtn = true;
          this.closeModal();
        });
    },

    cari() {
      this.LCari = true;

      const url = process.env.VUE_APP_API + "petajab/apr/" + this.SData.asn.nip;
      this.axios
        .get(url, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((res) => {
          this.LCari = false;
          this.SData.asn.id = res.data.mapData[0].idASN;
          this.SData.asn.nip = res.data.mapData[0].asn.nip;
          this.SData.asn.nama = res.data.mapData[0].asn.nama;
        })
        .catch((error) => {
          SView.commit("refreshData", true);
          SView.commit("alert", error.response.data.message);
          SView.commit("gagalAlert", true);
          SView.commit("berhasilAlert", false);
          SView.commit("success", error.response.data.success);
          console.log(error.response.status);
          console.log("Error", error.message);
          this.LCari = true;
        });
    },

    async closeModal() {
      await SView.commit("refreshData", true);
      this.reset();
      this.ModalEdit = false;
    },
  },
};
</script>
